'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class WowcherButton extends _react.default.Component {
  constructor(props) {
    super(props);
    this.updatePromo = this.updatePromo.bind(this);
  }
  updatePromo(e) {
    this.props.updateAgent(e.target.value);
  }
  render() {
    const {
      agent,
      showPromoCode,
      wowcherCode
    } = this.props;
    if ((!agent || agent !== wowcherCode) && !showPromoCode) return null;
    const minLength = showPromoCode ? 4 : 12;
    const promoLabel = showPromoCode ? 'Discount' : 'Voucher';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group wowcher"
    }, /*#__PURE__*/_react.default.createElement("label", null, promoLabel, " Code"), /*#__PURE__*/_react.default.createElement("input", {
      required: !showPromoCode,
      minLength: minLength,
      className: "form-control wowcherField",
      type: "text",
      name: "LaunchID",
      placeholder: "Enter code here",
      onChange: this.updatePromo
    }));
  }
}
WowcherButton.propTypes = {
  agent: _propTypes.string,
  showPromoCode: _propTypes.bool
};
WowcherButton.defaultProps = {
  showPromoCode: false
};
var _default = exports.default = WowcherButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/wowcherPromo.js
// module id = 400
// module chunks = 119